// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2F864","info":"PatientInfo_info__1nQEh"};